import { useMemo } from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import SgCepLobSpecificUtil from 'sg-cep-lob-specific-util';
import metadata from './SgRenewalProposalsSummary.metadata.json5';
import SgRenewalProposalTile from './sg-renewal-proposal-tile/SgRenewalProposalTile';

function SgRenewalProposalsSummary(props) {
    const {
        renewals
    } = props;

    const filteredRenewals = renewals.filter((item) => item && !SgCepLobSpecificUtil.shouldBlockThirdPartyPolicy(item.productCode, item));

    const generateOverrides = useMemo(() => {
        const overrides = filteredRenewals.map((item, index) => {
            return {
                [`cepRenewalTile${index}`]: {
                    renewal: item
                }
            };
        });
        return Object.assign({}, ...overrides);
    }, [filteredRenewals]);

    const overrides = {
        cepRenewalProposalsTiles: {
            data: filteredRenewals
        },
        sgRenewalProposalsSummaryHeader: {
            visible: !!renewals.length
        },
        ...generateOverrides
    };
    const resolvers = {
        resolveComponentMap: {
            SgRenewalProposalTile: SgRenewalProposalTile
        }
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

export default SgRenewalProposalsSummary;
